import React from 'react';

import ItemOptionQuestionPresentation from './ItemOptionQuestionPresentation';

export default class ItemOptionQuestion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAllTextOption: false,
        };
    }

    handleShowAllTextOption(currentShowAllTextOption) {
        this.setState({ showAllTextOption: !currentShowAllTextOption });
    }

    render() {
        const {
            option,
            handleRemoveItemsOptionQuestion,
            handleSelectCorrectOptionQuestion,
            enableEditMode,
            editMode,
        } = this.props;
        const { showAllTextOption } = this.state;
        return (
            <ItemOptionQuestionPresentation
                option={option}
                handleSelectCorrectOptionQuestion={
                    handleSelectCorrectOptionQuestion
                }
                handleRemoveItemsOptionQuestion={
                    handleRemoveItemsOptionQuestion
                }
                handleShowAllTextOption={this.handleShowAllTextOption.bind(
                    this,
                )}
                showAllTextOption={showAllTextOption}
                enableEditMode={enableEditMode}
                editMode={editMode}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/add-question/components/ItemOptionQuestion/index.js